<template>
  <div class="wrap">
    <div class="top_vue">
      <button class="back_vue" @click="handleClick">
        <i class="icon"></i>
      </button>
    </div>
    <iframe :src="iframeSrc" frameborder="0"></iframe>
  </div>
  
</template>

<script>
import client from "../client/client";
import Loading from "../components/Loading";
import { useRoute } from 'vue-router'

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

export default {
  name: "RecipeDetail",
  components: {
    Loading,
    Swiper,
    SwiperSlide,
  },
  data: function () {
    const route = useRoute()
    const { query } = route;
    return {
      loading: true,
      query: query,
      reply: [],
      recipe: {},
      ingredient: '',
      reply_count: 0,
      iframeSrc: '',
    };
  },
  methods: {
    async update() {
      this.loading = true;
      const route = useRoute()
      const { query } = route;
      client.updateToken(query);
      const recipe_id = query.id;
      this.iframeSrc = `https://m.oh-bab.com/recipe/recipe_${recipe_id}.html`;
      console.log('iframeSrc => ', this.iframeSrc);
    },
    handleAlert() {
      alert("앱으로 확인해주세요.");
    },
    handleClick() {
      this.$router.back();
    },
    handleLinkClick() {
      window.open('https://todaymeal.page.link/recipe', '_blank');
    }
  },
  async mounted() {
    this.update();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";
.bg2 {
  z-index: 0;
  position: fixed;
  top:50%;
  left:70%;
  transform: translateY(-50%);
  width:395px;
}
.wrap {
  background:#DEDEDE;
  position: relative;
  width:100vw;
  height:100vh;
}
iframe {
  width:100%;
  height:100%;
  .back {
    display: none !important;
  }
}
.top_vue {
  position:absolute;
  top:0;
  left:50%;
  transform: translateX(-50%);
  background:#fff;
  width:100%;;
  max-width: 640px;
  .back_vue {
    z-index: 5;
    background: #fff;
    cursor: pointer;
    .icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='19'%3E%3Cpath fill='%23000' fill-rule='evenodd' d='m1.212 9.037.277-.276c.035-.035.073-.068.112-.097L9.1 1.21a1 1 0 0 1 1.41 0l.273.271a1 1 0 0 1 .004 1.415L3.892 9.75l6.89 6.852a1 1 0 0 1 .004 1.414l-.277.275a1 1 0 0 1-1.41 0l-7.498-7.455a1.008 1.008 0 0 1-.112-.097l-.273-.272a.996.996 0 0 1-.293-.647v-.135a.996.996 0 0 1 .289-.648Z'/%3E%3C/svg%3E");
    }
  }
}

.app_link {
  background: #F2632A;
  border-radius: 10px;
  width: calc(100% - 30px);
  max-width: 600px;
  position:fixed;
  bottom:30px;
  font-size: 18px;
  color: #FFFFFF;
  z-index: 999;
  border:0;
  left:50%;
  transform: translateX(-50%);
  padding:20px 4px;
}
.back {
  position: absolute;
  top:8px;
  left:8px;
  z-index: 5;
  background: transparent;
  cursor: pointer;
  .icon {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='32' height='32'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h32v32H0z'/%3E%3Cimage xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAYAAADeB1slAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAJgAAAAD8JHNKAAABfUlEQVRIDdWWW07DQAxFS8sGeLZNNsGeASFgA+U5lVgIfCH45R+Fc6WONIo88zGegLBkJXGUY1/PK7PZf7JhGI4mqRfwCX6Ov+LX+GmzRMB6POCp3fCw504CZIlvUvLu/oPrgSsBAKvymOuSm3l1Aj5W5XeRNrpueV574KXK74H3HrgqF8SyQLDzwDsAzxaZmNrlgqvyhwz8yQtX5SEDV7tcA/pnlatdK8+ArgDkev7IO9eArgFosVimnk9WuRS5Ku8BvFhlE9M8X3p6vgBwW4DXT0VVBVgHxqeR4IvYWXXl8UMgc9xS8E1cA+s/oYBoUeX2GsV9bdq1SlNUFVumJPUDnbRL45FbZIF3zZTkkjRVUmpXEyWlPampEq1ky5rNLinRLmrZrymp3wiTKVxSEpBXv5UnSbRONlaviKldkyvRYdVEyTGgnBL9wi+i6uorEO1d+i8a2zuBw2pw+iEgS8kFcb+CmAhYh1/hb7jOlfof4AgdX4Hq0FKi/fTdD/QtZYWmd7WtAAAAAElFTkSuQmCC' width='12' height='19' x='9' y='6'/%3E%3C/g%3E%3C/svg%3E");
  }
}
.top_gra {
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index: 2;
  background-image: linear-gradient(180deg, rgba(0,0,0,0.20) 0%, rgba(0,0,0,0.00) 52%);
}
.mySwiper {
  cursor: pointer;
  width: 100%;
  height: 100%;
  background: #000;
  // swiper-slide {
  //   background: #000;
  // }
  image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.mt12{
  margin-top:12px !important;
}
body {
  background-color: #eee !important;
}
button {
  border:none;
  background: #fff;
  padding:0;
  margin:0;
  cursor: pointer;
}
.img-wapper {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  // height: 0;
  // padding-bottom:56.26%;
  overflow: hidden;
  img {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    width: 100%;
    height:100%;
    object-fit: cover;
  }
}
hr{
  height:1px;
  border:0;
  margin:0;
  padding:0;
}
.top{

}

.reply_hr{
 height:10px;
 background:#F4F4F4;
 margin-bottom:12px;
}
.content {
  .user_info {
    padding:16px;
    line-height: 1em;
    position: relative;
    dl{
      padding-left:52px;
      margin-bottom:0;
      dt{
        display: flex;
        align-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 4px;
        .label{
          display: inline-block;
          padding: 0.4em 4px;
          font-size: 10px;
          height: 2em;
          line-height: 1.2em;
          font-weight: 400;
          color: #fff;
          background-color: #ff6b6b;
          border-radius: 4px;
        } 
      }
      dd{
        font-size:12px;
        font-weight: 400;
        margin-bottom:0;
      }
    }
    .profile {
      position: absolute;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      top:50%;
      transform: translate(0, -50%);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .user_info_line{
    background:#F4F4F4;
    margin:0 16px;
  }

  .recipe_header{
    position: relative;
    padding:24px 16px 16px;
    .bookmark_ic {
      position: absolute;
      top: 50%;
      right:16px;
      transform: translate(0, -50%);
    }
    h3{
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 4px;
      margin-right:34px;
    }
    .recipe_info {
      font-size: 12px;
      font-weight: 400;
      color: #656565;
      margin-right:34px;
      .recipe_info_item{
        display: inline-block;
        padding-right: 16px;
        position: relative;
        em {
          color: #F2632A;
          font-style: initial;
        }
        &::before {
          content: '';
          width:1px;
          height:8px;
          background: #656565;
          position: absolute;
          right:8px;
          top:50%;
          transform: translate(0, -50%);
        }
        &:last-child{
          margin-right:0;
          &::before {
            display: none;
          }
        }
      }
    }
  }
  .recipe_ingredients {
    background: #F4F4F4;
    border-radius: 8px;
    padding: 16px;
    margin:16px;
    li {
      list-style: none;
      font-size: 12px;
      font-weight: 400;
      color: #000000;
      line-height: 1.6em;
      &:last-child{
      }
    }
  }
  .recipe_content {
    padding: 16px 16px 46px;
    margin:0;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 1.6em;
  }
}
.reply_header {
  padding: 16px;
  
  .reply_info {
    display: flex;
    align-items: center;
    margin-bottom:24px;
    h4{
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 4px;
      display: inline-block;
      margin-right:auto;
    }
    .reply_count{
      font-size: 16px;
      font-weight: 700;
      color: #F2632A;
    }
    .reply_sort__select{
      padding: 0 8px;
      font-size: 12px;
      font-weight: 400;
      color: #343434;
      cursor: pointer;
    }
  }
  .reply_input {
    position: relative;
    margin-left:40px;
    .reply_bottom_input {
      border-radius: 0;
      border:0;
      font-size: 16px;
      color: #777777;
      width: 100%;
      height: 30px;
      padding: 0 8px;
      outline: none;
    }
    .profile {
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      top:50%;
      left:-40px;
      transform: translate(0, -50%);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }  
}

.reply_content {
  .reply_card {
    padding: 0 16px 16px;
    .reply_card__header {
      position: relative;
      padding:0 48px 0 48px;
      .profile {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        top:50%;
        left:0;
        transform: translate(0, -50%);
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .reply_card__more_ic {
        position: absolute;
        top: 50%;
        right:0;
        transform: translate(0, -50%);
        padding:4px 13px;
      }
      .reply_card__info {
        h3{
          font-size: 12px;
          font-weight: 700;
          color: #000000;
          margin-bottom: 4px;
        }
        p {
          margin-bottom: 0;
          color: #656565;
          font-size:10px;
          font-weight: 400;
        }
      }
    }
    .reply_card__content {
      margin:10px 0 10px;
    }

    .reply_card__footer {
      display: flex;
      align-items: center;
      margin-left:-8px;
      button {
        color: #666666;
        font-size: 12px;
        padding:4px 8px;
      }
    }
    .reply_card__hr {
      margin:16px 16px 0;
      height:1px;
      background: #F4F4F4;
    }
  }
}

.reply_bottom {
  position:fixed;
  align-items: center;
  bottom:0;
  background:#fff;
  width:100%;
  max-width: 640px;
  left:50%;
  transform: translate(-50%,0);
  padding:24px 16px 18px; 
  display: flex;
  .profile {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 2px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  input {
    font-size:16px;
    color:#000000;
    padding:0 16px;
    outline: none;
    border:none;
    flex:1;
  }
  button {
    width:44px;
    height:40px;
    color: #fff;
    background: #F2632A;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.selectBg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  > ul {
    width: 260px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    list-style: none;
    z-index: 9999;
    background: #fff;
    margin: 0;
    padding: 12px 16px;
    border: 1px solid #7e7e7e;
    border-radius: 6px;
    li {
      margin: 0;
      padding: 16px 0;
      border-bottom: 1px solid #fafafa;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
.mobile_wrap {
  position: relative;
  z-index: 2;
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  padding-bottom:82px;
  > div {
    display: flex;
    flex-direction: column;
    min-height: calc( 100vh - 82px );
  }
}
</style>
